import React from 'react';
import { Spinner } from '@isyc-react/design/bootstrap';
import { ErrorContentLayout } from 'layout';
import { DossierOccupants } from './dossier-occupants.component';
import { useOccupantReadQuery } from 'common-app/api/query/occupant-read';
import { useDossierContext } from 'common-app/dossier';
export const DossierOccupantsContainer = () => {
    const { dossier } = useDossierContext();
    const { data, loading, error } = useOccupantReadQuery({ variables: { dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id } });
    return (React.createElement(React.Fragment, null, loading ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
            React.createElement(Spinner, { animation: 'border' })))) : (React.createElement(React.Fragment, null, (data === null || data === void 0 ? void 0 : data.read_occupant) ? (React.createElement(DossierOccupants, { others: data.read_occupant })) : (React.createElement(ErrorContentLayout, null,
        React.createElement("h1", { className: 'text-primary' }, "Erreur de occupants"),
        React.createElement("p", null, "Impossible d'obtenir les donn\u00E9es du occupants")))))));
};
